/* eslint-disable class-methods-use-this */
import Model from './Model';

export default class FrameworkCategory extends Model {
    // noinspection JSMethodCanBeStatic
    resource() {
        return 'framework_categories';
    }
}
